module.exports = "../../app/cells/components/modals/crop_image_modal_cell.rb";